import { http } from '@pendo/http';

export function queryMetadataValues (kind, group, field, query) {
    return http.get(`/api/s/_SID_/metadata/${kind}/${group}/schema/${field}/values?filter=${query}`);
}
